import React from "react";

import {bindActionCreators} from "redux";
import {NavLink, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import CloudFlyerAPI from "../../api/CloudFlyerAPI";
import {receiveError} from "../../api/http";

import {Modal, Button, message, Table, Tooltip, Input, Space, Checkbox} from "antd";


import "./productSubscriptionDashboard.scss";
import {DeleteFilled, SendOutlined} from "@ant-design/icons";
import arrowLeft from "../../assets/img/icon/arrow-left-icon.svg";
import queryString from "query-string";

const {Search} = Input;

class ProductSubscriptionDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            subscription: [],
            modalData: {},
            pageSize: 50,
            page: 1,
            total: 0,
            userID: "",
            username: "",
            visible: false
        };
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }

    componentDidMount() {
        setTimeout(() => {
            const queryParams = queryString.parse(this.props.location.search);
            const id = queryParams.id;
            const username = queryParams.username;
            this.setState({userID: id, username: username, loading: true});
            console.log(id)
            this.fetchAllUsers();

        }, 0);
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    fetchAllUsers() {
        CloudFlyerAPI.admin_subscription
            .getAllSubscription(this.state.pageSize, this.state.page, this.state.userID)
            .then(({data}) => {
                console.log(data)
                this.setState({
                    loading: false,
                    subscription: data.data,
                    pageSize: data?.options?.pageSize,
                    page: data?.options?.page,
                    total: data?.total,
                });
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }

    onPageChange = page => {
        this.setState({page: page, loading: true})
        this.fetchAllUsers();
    }

    handleDeleteClick(id) {
        CloudFlyerAPI.admin_subscription
            .deleteSubscription(id)
            .then(({data}) => {
                console.log(data)
                this.setState({
                    loading: true,
                });
                this.fetchAllUsers();
            })
            .catch((err) => {
                const msg = receiveError(null, err).message;
                message.error(msg);
            });
    }

    render() {
        const {history} = this.props;
        const showDeleteConfirm = (
            e,
            handleDeleteClick,
            id) => {
            e.stopPropagation()
            Modal.confirm({
                title: `Are you sure you want to Delete this Subscription?`,
                content:
                    "",
                onOk() {
                    handleDeleteClick(id)
                }
            })
        }

        function getFormatedDate(date, includeTime = true) {
            const d = new Date(date);

            var hours = d.getHours();
            var minutes = d.getMinutes();
            var ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0' + minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            if (includeTime) {
                return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear() + " " + strTime;
            } else {
                return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
            }
        }


        const columns = [
            {
                title: "Name",
                key: "name",
                dataIndex: "name",
                width: 100,
            },
            {
                title: "Type",
                dataIndex: "subscriptionType",
                key: "subscriptionType",
                width: 70,
            },
            {
                title: "Payment Method",
                dataIndex: "paymentMethod",
                key: "paymentMethod",
                width: 90,
            },
            {
                title: "Status",
                dataIndex: "status",
                key: "status",
                width: 90,
            },
            {
                title: "Start Date",
                dataIndex: "startDate",
                key: "startDate",
                width: 90,
            },
            {
                title: "End Date",
                dataIndex: "endDate",
                key: "endDate",
                width: 90,
            },
            {
                title: 'Action',
                dataIndex: 'action',
                key: 'action',
                width: 100,
                ellipsis: {
                    showTitle: false,
                },
                render: action => (
                    <div className="userActions">
                        <Tooltip placement="topLeft" title="Detail">
                            <Button
                                className="replication-delete-btn"
                                icon="exception"
                                onClick={e => {
                                    this.setState({
                                        modalData: action.postData.data,
                                        visible: true,
                                    })
                                }
                                }
                            />
                        </Tooltip>
                        <Tooltip placement="topLeft" title="Delete">
                            <DeleteFilled className={action.status} onClick={e =>
                                showDeleteConfirm(e, this.handleDeleteClick, action.id,)
                            }/>
                        </Tooltip>
                    </div>
                ),
            }
        ];


        let subscriptionType = new Map();
        subscriptionType.set(1, "App");
        subscriptionType.set(2, "Storage");
        subscriptionType.set(4, "AdminUser");
        subscriptionType.set(8, "CreativeUser");
        subscriptionType.set(16, "StandardUser");
        subscriptionType.set(32, "Connection");
        subscriptionType.set(64, "Project");
        subscriptionType.set(128, "Team");
        subscriptionType.set(256, "Drive");
        subscriptionType.set(512, "Sync");
        subscriptionType.set(1024, "SSO");
        subscriptionType.set(2048, "Logs");
        subscriptionType.set(4096, "FreeUser");
        subscriptionType.set(8192, "FreeConnection");


        let paymentMethod = new Map();
        paymentMethod.set(1, "Stripe");
        paymentMethod.set(2, "DirectTransfer");

        let status = new Map();
        status.set(1, "Pending");
        status.set(2, "Active");
        status.set(4, "Cancelled");
        status.set(8, "Expired");


        let data = this.state?.subscription?.map((t, index) => {
            return {
                key: t.id,
                id: t.id,
                name: t.featureName === null ? t.packageName : t.featureName,
                productPackageId: t.productPackageId,
                productFeatureId: t.productFeatureId,
                startDate: getFormatedDate(t.startDate, false),
                endDate: getFormatedDate(t.endDate, false),
                subscriptionType: subscriptionType.get(t.subscriptionType),
                paymentMethod: paymentMethod.get(t.paymentMethod),
                paymentReference: t.paymentReference,
                featureReference: t.featureReference,
                status: status.get(t.status),
                action: {
                    id: t.id,
                    postData: {
                        data: t,
                        id: t.id
                    },
                    detailData: {id: t.id, name: t.accountName, accountId: t.accountId}
                }
            };
        });

        const packageColumns = [
            {
                title: '',
                dataIndex: 'attribute',
                key: 'attribute',
            },
            {
                title: '',
                dataIndex: 'value',
                key: 'value',
                align: 'center',
            },
        ];

        const subscriptionData = [
            {key: '1', attribute: 'Name', value: this.state.modalData.featureName === null ? this.state.modalData.packageName : this.state.modalData.featureName},
            {key: '2', attribute: 'Subscription Type', value: subscriptionType.get(this.state.modalData.subscriptionType)},
            {key: '3', attribute: 'Payment Method', value: paymentMethod.get(this.state.modalData.paymentMethod)},
            {key: '5', attribute: 'Status', value: status.get(this.state.modalData.status)},
            {key: '5', attribute: 'Payment Reference', value: this.state.modalData.paymentReference},
            {key: '5', attribute: 'Feature Reference', value: this.state.modalData.featureReference},
            {key: '5', attribute: 'Start Date', value: getFormatedDate(this.state.modalData.startDate, false)},
            {key: '5', attribute: 'End Date', value: getFormatedDate(this.state.modalData.endDate, false)},
        ];

        return (
            <div className="usersListdashboard">
                <div className="header">
                    <div className="left-wrapper">
                        <h2 className="title-back"><NavLink to="/userList"><img src={arrowLeft} alt="icon"/></NavLink>Subscription</h2>
                    </div>
                    <div className="right-wrapper">
                        <Button
                            className="add-user-btn"
                            type="primary"
                            style={{width: "182px"}}
                            onClick={() => history.push("/addNewSubscription?id=" + this.state.userID + "&username=" + this.state.username)}>
                            Add New Subscription
                        </Button>
                    </div>
                </div>

                <h3 className="mt-title"> {this.state.username}</h3>
                <div className="active-jobs-wrapper-list">
                    <Table
                        loading={this.state.loading}
                        columns={columns}
                        dataSource={data}
                        pagination={{
                            onChange: this.onPageChange,
                            total: this.state.total,
                            current: this.state.page,
                            showTotal: (total, range) =>
                                `${range[0]}-${range[1]} of ${total} items`,
                            pageSize: this.state.pageSize,
                        }}
                        scroll={{y: 600}}
                    />

                </div>

                <Modal
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button onClick={this.handleCancel}>
                            Cancel
                        </Button>,
                        <Button type="primary" onClick={() => {


                            const queryString = encodeURIComponent(JSON.stringify(this.state.modalData));

                            this.props.history.push("/editSubscription/?data=" + queryString+"&username=" + this.state.username );
                        }}>
                            Edit
                        </Button>,
                    ]}
                    className={"detail-modal"}
                >
                    <h3 className="text-center">Subscription Detail</h3>
                    <Table columns={packageColumns} dataSource={subscriptionData} pagination={false} bordered size="small" showHeader={false}/>
                </Modal>
            </div>
        );
    }
}

export default withRouter(
    connect(
        ({auth, cloudAccounts}, {match, history}) => {
            let user = auth.user;
            return {
                ...user,
                cloudAccounts,
            };
        },
        (dispatch) => bindActionCreators({}, dispatch)
    )(ProductSubscriptionDashboard)
);
